// @ts-strict-ignore
import { defaultEmarsysTracking } from './default-emarsys-tracking'
import { typedWindow } from './helpers/types'
import { CartFragmentFragment } from '@generated'
import { useEmarsysStore } from '@lib/use-emarsys-store'

type ProductVisit = {
  productId: string
  customerId?: number
  cart: null | CartFragmentFragment
}

export function emarsysProductVisit({ productId, customerId, cart }: ProductVisit) {
  if (typedWindow.ScarabQueue) {
    typedWindow.ScarabQueue.push(['view', productId])

    if (typedWindow && typedWindow.ScarabQueue) {
      typedWindow.ScarabQueue.push([
        'recommend',
        {
          logic: 'RELATED',
          success: handleSuccess,
          containerId: 'related-products',
        },
      ])
    }

    defaultEmarsysTracking({ customerId, cart })
  }
}

function handleSuccess(SC: any) {
  const setProductIds = useEmarsysStore.getState().setProductIds

  if (SC.page?.products && SC.page?.products.length > 0) {
    setProductIds(
      'related',
      SC.page.products.map((product) => product.id),
    )
  }
}
